define.alias("shared/components/shared/credentials/tiktok-refresh", "settings/components/shared/credentials/tiktok-refresh");